module.exports = __webpack_public_path__ + "static/media/FrownFace.a37d819f.svg";